<template>
  <div class="searchBox">
    <h2>{{ lang == "zh" ? "搜索结果" : "SEARCH" }}</h2>
    <div class="search">
      <input v-model="keyWord" @input="getList(1)" />
      <i class="el-icon-search"></i>
    </div>
    <div class="wrap searchList">
      <NewsList :newsList="newsList" />
      <div class="pageBox" v-if="showPage">
        <Pagination
          v-if="PagingInfo.TotalPages"
          @pageChange="getList"
          :PagingInfo="PagingInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NewsList from "./components/NewsList";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";

export default {
  data() {
    return {
      newsList: [],
      keyWord: "",
      PagingInfo: [],
      lang: this.$global.lang,
      pageCur: 1,
      showPage: false,
    };
  },
  components: {
    NewsList,
    Pagination,
  },
  beforeRouteEnter(to, from, next) {
    let fromURL = from.name;
    next((vm) => {
      if (fromURL == "newsContent") {
        vm.pageCur = sessionStorage.getItem("currentPage");
        vm.keyWord = sessionStorage.getItem("keyWord");
        vm.getList(vm.pageCur);
      }
    });
  },
  methods: {
    getList(page) {
      sessionStorage.setItem("keyWord", this.keyWord);
      this.$api
        .search({
          Type: "string",
          Key: this.keyWord,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { NewsItems, PagingInfo } = res.Value;
          this.PagingInfo = PagingInfo;
          this.newsList = NewsItems;
          this.showPage = true;
          this.$nextTick(() => {
            new WOW({
              boxClass: "wow",
              animateClass: "animate__animated",
              live: false,
            }).init();
          });
        });
    },
  },
};
</script>

<style lang="scss">
.searchBox {
  text-align: center;
  padding: 50px 0;
  h2 {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 50px;
  }
}
.search {
  width: 800px;
  height: 66px;
  border: 1px solid #bfbfbf;
  position: relative;
  margin: auto auto 50px auto;
  overflow: hidden;
  box-sizing: border-box;
  input {
    width: 100%;
    height: 66px;
    border: none;
    background: #fff;
    line-height: 66px;
    padding: 0 50px 0 20px;
    font-size: 16px;
    &:focus {
      border: none;
    }
  }

  i {
    font-size: 26px;
    position: absolute;
    right: 20px;
    top: 18px;
  }
  .searchList {
    margin-top: 50px;
  }
}
</style>